// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"a86a9486","375":"f6433200"}[chunkId] + ".chunk.css";
};